<div class="dialog-header">
  <h2>Changes Log</h2>
  <button class="x-btn" (click)="close()">&#10005;</button>
</div>

<div class="dialog-body">
  <div class="log-item" *ngFor="let log of logs">
    <p>
      <a class="user-link">{{ log.username }}</a>
      {{ log.message }}
      <a class="customer-link">{{ log.customer }}</a>
      at {{ log.date }}
    </p>
  </div>
  <div *ngIf="logs.length === 0" class="empty">No logs found.</div>
</div>

<div class="dialog-footer">
  <button class="close-btn" (click)="close()">Close</button>
</div>
